<template>
    <el-dialog v-model="dialog_opened" width="30%" title="应用实验分组">
        <el-form label-width="100px">
            <el-form-item label="实验名称">
                {{exp.name}}
            </el-form-item>
            <el-form-item label="报告范围" required>
                <date-range-picker v-if="form.start && form.end" v-model="form" :disabled="loading"></date-range-picker>
            </el-form-item>
            <el-form-item label="选择分组" :rules="[{required: true, message: '请选择实验分组'}]">
                <el-radio-group v-model="selected" :disabled="loading" >
                    <el-radio v-for="(g, i) in exp.groups" :key="i" :label="i">{{`${g.name}(${g.tag})`}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <el-row style="text-align: right; margin-top: 10px">
            <el-button @click="reset()"  :loading="loading">取消</el-button>
            <el-button @click="apply()"  type="primary" :loading="loading">确认</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import axios from 'ts-axios-new';
import DateRangePicker from "../../../base/DateRangePicker";
import {timestampToDate} from "../../../libs/utils";

export default {
    name: "ExpApplyDialog",
    components: {DateRangePicker},
    data() {
        return {
            dialog_opened: false, loading: false, exp: {}, selected: null,
            form: {
                start: '',
                end: '',
            },
        }
    },
    methods: {
        openDialog(exp) {
            this.exp = exp;
            this.form = this.getReportRange(exp);
            this.dialog_opened = true;
        },
        reset() {
            this.dialog_opened = false;
            this.loading = false;
            this.selected = null;
            this.form = {
                start: '',
                end: '',
            };
        },
        getReportRange(exp) {
            if (exp.report_start && exp.report_end) {
                return {
                    start: exp.report_start,
                    end: exp.report_end,
                };
            }
            const end = exp.finish_time ? timestampToDate(exp.finish_time) : timestampToDate(Date.now() - 24 * 3600 * 1000);
            let start = timestampToDate(new Date(end) - 15 * 24 * 3600 * 1000);
            const publishDate = exp.publish_time ? timestampToDate(exp.publish_time) : '';
            if (publishDate && start < publishDate) {
                start = publishDate;
            }
            return {start, end};
        },
        apply() {
            if (this.selected === null) {
                this.$message.warning("请选择实验分组!");
                return
            }
            if (!this.form.start || !this.form.end) {
                this.$message.warning("请选择报告范围!");
                return
            }
            const api = this.$root.$getElasticDomain() + '/cms/v1/abtest/exp/' + this.exp.id + '/status';
            this.$confirm('确定要应用该组吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.post(api, {
                    status: 'finished',
                    apply: this.selected,
                    report_start: this.form.start,
                    report_end: this.form.end,
                }).then(res => {
                    this.$message.success("应用成功!")
                    this.$emit("afterSave");
                    this.reset();
                })
            }).catch(_ => {
            })
        },
    }
};
</script>

<style scoped>

</style>
